import * as appVerionTypes from '../actionTypes/appVerionTypes';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { serverNotRespond } from "../../helper/ApiToast";
import { orgDetailsFetch ,downloadSDKandDOCservice} from '../../services/appReleaseServices';

/**
 * @param  {object} obj={}
 * internal Release
 */
export function* customReleaseGetOrgDetails(obj = {}) { //getorganization name
    try {
        const orgDetails = yield call(orgDetailsFetch, obj);
        const { data = {} } = orgDetails || {};
        if (data.status >= 200 && data.status <= 300) {
            yield all([
                put({ type: "DO_SEARCH_ORG_DETAILS_LOAD", orgDetailsSearchLoad: false }), //STORE ORG DETAILS
                put({ type: "DO_STORE_CUTOM_RELEASE_ORG_DETAILS", customReleasOrgDtls: data }), //STORE ORG DETAILS
            ]);
        } else {
            yield all([
                put({ type: "DO_SEARCH_ORG_DETAILS_LOAD", orgDetailsSearchLoad: false }), //STORE ORG DETAILS
            ]);
        }
    } catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
        yield all([
            put({ type: "DO_SEARCH_ORG_DETAILS_LOAD", orgDetailsSearchLoad: false }), //STORE ORG DETAILS
        ]);
    }
}
function* downLoadAppSDKandDOC(obj = {}) {
    const { data: { name = "" } = {} } = obj || {};
    try {
        const downloadSdkandDoc = yield call(downloadSDKandDOCservice, obj);
        const { data = {}, status = 0 } = downloadSdkandDoc || {};
        if (status === 200) {
            const headerval = downloadSdkandDoc.headers['content-disposition'];
            const filename = headerval.split(';')[1].split('=')[1].replace('"', '').replace('"', '');
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name ? name : filename);
            document.body.appendChild(link);
            link.click();
            yield all([
                put({ type: "ADD_SDK_DOC_FILE", addSdkDocFile: false }), //loader false
            ]);
        } else {
            yield all([
                put({ type: "ADD_SDK_DOC_FILE", addSdkDocFile: false }), //loader false
            ]);
        }
    } catch (error) {
        serverNotRespond(); //serverIs Not Respont Call this Toast
        yield all([
            put({ type: "ADD_SDK_DOC_FILE", addSdkDocFile: false }), //loader false
        ]);
    }
}
function* downLoadLatestVersionSDk(obj = []) {
    const { data = [] } = obj || {};
    try {
        for (let i = 0; i <= data.length; i++) {
            yield all([
                call(downLoadAppSDKandDOC, { data: { fileToken: data[i].fileUrl } }),
                call(downLoadAppSDKandDOC, { data: { fileToken: data[i].documentUrl } })
            ]);
        }
    } catch (e) {
        yield all([
            // put({ type: "ADD_SDK_DOC_FILE", addSdkDocFile: false }), //loader false
        ]);
    }
}
function* downLoadLatestVersionserverConfig(obj = {}) {
    try {
        yield all([
            call(downLoadAppSDKandDOC, obj)
        ]);
    } catch (e) {
        yield all([
            // put({ type: "ADD_SDK_DOC_FILE", addSdkDocFile: false }), //loader false
        ]);
    }
}
export default function* rootAppReleasePostSaga() {
    yield takeLatest(appVerionTypes.APP_CUSTOM_RELEASE_ORG_DETAILS, customReleaseGetOrgDetails);
    yield takeLatest(appVerionTypes.DOWNLOAD_SDK_COC, downLoadAppSDKandDOC);
    // yield takeLatest(appVerionTypes.DOWNLOAD_LATEST_VERSION_SDK_DOWNLOAD, downLoadLatestVersionSDk);
    // yield takeLatest(appVerionTypes.DOWNLOAD_LATEST_VERSION_SERVER_CONFIG_DOWNLOAD, downLoadLatestVersionserverConfig);

}
